import { Box, Typography } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { NavLink } from "react-router-dom";
import { Button } from "react-bootstrap";

const CustomButton = ({ tittle = "Primary Btn", btnwidth = '150px', bcolor = '#fff', tcolor = 'rgb(144,202,37)', link = null, padding = 'auto', circlWidth = '35px', circlHeight = '35px' }) => {
  return (
    <Box>
        <NavLink
        to={link}
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: 'center',
            gap: "0",
            textDecoration: "none",
            position: 'relative',
            width: `${btnwidth}`
        }}
        >
        <Button style={{backgroundColor: `${bcolor}`, border: 'none', color: `${tcolor}`, borderRadius: '25px', padding: `${padding}`, width: `calc(${btnwidth} - ${circlWidth})`}}>
            {tittle}
        </Button>
        <div style={{backgroundColor: `${tcolor}`, width: `${circlWidth}`, height: `${circlHeight}`, borderRadius: '50%', border: `.3rem solid ${bcolor}`, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <ArrowOutwardIcon sx={{color: `${bcolor}`}} />
        </div>
        <div style={{position: 'absolute', width: '80%', height: '50%', backgroundColor: `${bcolor}`, zIndex: '-1'}}></div>
        </NavLink>
    </Box>
    
  );
};

export default CustomButton;
